@if (!content().showVideo) {
<img [src]="image()"
    id="fullscreenImage"
    alt="fullscreen img"
    animate.enter="ds-fade-enter" animate.leave="ds-fade-leave" />
}
@if (content().showVideo) {
<ds-video-player [videoId]="content().video.id"
    [controller]="controller()"
    [thumbnailUrl]="content().video.thumbnailImage"
    [closedCaptions]="closedCaptions()"
    [fullscreen]="true"
    animate.enter="ds-fade-enter" animate.leave="ds-fade-leave" />
}
